import { gql, useLazyQuery } from "@apollo/client";
import { useState } from "react";
import { useSelector } from "react-redux";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import "../CommonPage.scss";

const queryFunction = (fields) => {
  const query = gql`
    query GetrequestSupportWithStatus($Status: String) {
    getrequestSupportWithStatus(Status: $Status) {
        _id
        ${fields?.join(" ")}
      }
    }
  `;
  return query;
};

const AdminRequestSupport = () => {
  // const Refetch = useSelector((store: any) => store.FormFieldData.refresh);
  const Tab = useSelector((store: any) => store.SelectedTabData.tab);
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState([]);
  const Key = "Admin_Request_Support";

  // const config = useMemo(
  //   () => ({
  //     dataKey: "getrequestSupportWithStatus",
  //     dateKeys: ["createdAt", "updatedAt", "Date"],
  //     deleteKeys: ["__typename"],
  //   }),
  //   []
  // );

  const [fetchAdminRequest, { data, loading: queryLoading, error }] = useLazyQuery(queryFunction([]), {
    fetchPolicy: "network-only",
    variables: { Status: Tab },
    onCompleted: () => {
      setIsLoading(false);
    },
    onError: () => {
      setIsLoading(false);
    },
  });

  // useEffect(() => {
  //   fetchAdminRequest();
  // }, [Refetch, Tab]);

  const { loading } = useFetchTableData(queryFunction, fetchAdminRequest, setIsLoading, Key);
  // const { loading: processDataLoading } = useProcessData(data, setFormData, config, error);
  const isLoading1 = queryLoading || isLoading;

  let statusTab = [{ name: "Unread" }, { name: "Open" }, { name: "Hold" }, { name: "Closed" }];
  return (
    <div>
      <div className="HeaderDiv">
        <p className="pageTitle">Admin Support Request</p>
        <div className="hr1ForPageTitle"></div>
      </div>
      <Tabs tabs={statusTab} />
      <HeaderDiv title={""} MoreActions={{ Is_Print: false }} />
      {isLoading1 ? (
        <Loading />
      ) : !formData?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <LoadTable title={`Issues`} data={formData} loading={isLoading1} error={error} />
      )}
    </div>
  );
};

export default AdminRequestSupport;
